(() => {
  'use strict';

  function initialize(scope = document) {
    scope.querySelectorAll('[data-rlc-session]').forEach((viewer) => {
      if (viewer.dataset.rlcSessionReady === 'true') return;

      const panels = Array.from(viewer.querySelectorAll('[data-rlc-session-panel]'));
      const controls = viewer.querySelector('[data-rlc-session-controls]');
      const previous = viewer.querySelector('[data-rlc-session-action="previous"]');
      const next = viewer.querySelector('[data-rlc-session-action="next"]');
      const replay = viewer.querySelector('[data-rlc-session-action="replay"]');
      if (panels.length < 2 || !controls || !previous || !next || !replay) return;

      let index = 0;
      const render = () => {
        panels.forEach((panel, position) => {
          panel.hidden = position !== index;
        });
        previous.disabled = index === 0;
        next.disabled = index === panels.length - 1;
        replay.disabled = index === 0;
      };

      previous.addEventListener('click', () => {
        index = Math.max(0, index - 1);
        render();
      });
      next.addEventListener('click', () => {
        index = Math.min(panels.length - 1, index + 1);
        render();
      });
      replay.addEventListener('click', () => {
        index = 0;
        render();
      });

      viewer.dataset.rlcSessionReady = 'true';
      render();
      controls.hidden = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

(() => {
  'use strict';

  function initializeCoverage(scope = document) {
    scope.querySelectorAll('.rlc-source--ledmask [data-source-role="interactive_product_finder"]').forEach((finder) => {
      if (finder.dataset.rlcCoverageReady === 'true') return;

      const choices = Array.from(finder.querySelectorAll('button.group'));
      const reset = finder.querySelector('button[aria-label="Start over"]');
      if (choices.length !== 4 || !reset) return;

      const select = (selected) => {
        choices.forEach((choice) => {
          choice.setAttribute('aria-pressed', String(choice === selected));
        });
      };

      choices.forEach((choice) => {
        choice.addEventListener('click', () => select(choice));
      });
      reset.addEventListener('click', () => {
        select(null);
        choices[0].focus();
      });

      select(null);
      finder.dataset.rlcCoverageReady = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeCoverage(), { once: true });
  } else {
    initializeCoverage();
  }
  document.addEventListener('shopify:section:load', (event) => initializeCoverage(event.target));
})();
